{
  "labels": {
    "paste": "Liitä",
    "pasteAsPlaintext": "Liitä pelkkänä tekstinä",
    "pasteCharts": "Liitä kaaviot",
    "selectAll": "Valitse kaikki",
    "multiSelect": "Lisää kohde valintaan",
    "moveCanvas": "Siirrä piirtoaluetta",
    "cut": "Leikkaa",
    "copy": "Kopioi",
    "copyAsPng": "Kopioi leikepöydälle PNG-tiedostona",
    "copyAsSvg": "Kopioi leikepöydälle SVG-tiedostona",
    "copyText": "Kopioi tekstinä",
    "copySource": "",
    "convertToCode": "",
    "bringForward": "Tuo eteenpäin",
    "sendToBack": "Vie taakse",
    "bringToFront": "Tuo eteen",
    "sendBackward": "Vie taaksepäin",
    "delete": "Poista",
    "copyStyles": "Kopioi tyyli",
    "pasteStyles": "Liitä tyyli",
    "stroke": "Piirto",
    "background": "Tausta",
    "fill": "Täyttö",
    "strokeWidth": "Viivan leveys",
    "strokeStyle": "Viivan tyyli",
    "strokeStyle_solid": "Yhtenäinen",
    "strokeStyle_dashed": "Katkoviiva",
    "strokeStyle_dotted": "Pisteviiva",
    "sloppiness": "Viivan tarkkuus",
    "opacity": "Peittävyys",
    "textAlign": "Tekstin tasaus",
    "edges": "Reunat",
    "sharp": "Terävä",
    "round": "Pyöristetty",
    "arrowheads": "Nuolenkärjet",
    "arrowhead_none": "Ei mitään",
    "arrowhead_arrow": "Nuoli",
    "arrowhead_bar": "Tasapää",
    "arrowhead_circle": "",
    "arrowhead_circle_outline": "",
    "arrowhead_triangle": "Kolmio",
    "arrowhead_triangle_outline": "",
    "arrowhead_diamond": "",
    "arrowhead_diamond_outline": "",
    "fontSize": "Kirjasinkoko",
    "fontFamily": "Kirjasintyyppi",
    "addWatermark": "Lisää \"Tehty Excalidrawilla\"",
    "handDrawn": "Käsinpiirretty",
    "normal": "Tavallinen",
    "code": "Koodi",
    "small": "Pieni",
    "medium": "Keskikoko",
    "large": "Suuri",
    "veryLarge": "Erittäin suuri",
    "solid": "Yhtenäinen",
    "hachure": "Vinoviivoitus",
    "zigzag": "",
    "crossHatch": "Ristiviivoitus",
    "thin": "Ohut",
    "bold": "Lihavoitu",
    "left": "Vasen",
    "center": "Keskitä",
    "right": "Oikea",
    "extraBold": "Erittäin lihavoitu",
    "architect": "Arkkitehti",
    "artist": "Taiteilija",
    "cartoonist": "Sarjakuva",
    "fileTitle": "Tiedostonimi",
    "colorPicker": "Värin valinta",
    "canvasColors": "Käytössä piirtoalueella",
    "canvasBackground": "Piirtoalueen tausta",
    "drawingCanvas": "Piirtoalue",
    "layers": "Tasot",
    "actions": "Toiminnot",
    "language": "Kieli",
    "liveCollaboration": "Live Yhteistyö...",
    "duplicateSelection": "Monista",
    "untitled": "Nimetön",
    "name": "Nimi",
    "yourName": "Nimesi",
    "madeWithExcalidraw": "Tehty Excalidrawilla",
    "group": "Ryhmitä valinta",
    "ungroup": "Pura valittu ryhmä",
    "collaborators": "Yhteistyökumppanit",
    "showGrid": "Näytä ruudukko",
    "addToLibrary": "Lisää kirjastoon",
    "removeFromLibrary": "Poista kirjastosta",
    "libraryLoadingMessage": "Ladataan kirjastoa…",
    "libraries": "Selaa kirjastoja",
    "loadingScene": "Ladataan työtä…",
    "align": "Tasaa",
    "alignTop": "Tasaa ylös",
    "alignBottom": "Tasaa alas",
    "alignLeft": "Tasaa vasemmalle",
    "alignRight": "Tasaa oikealle",
    "centerVertically": "Keskitä pystysuunnassa",
    "centerHorizontally": "Keskitä vaakasuunnassa",
    "distributeHorizontally": "Jaa vaakasuunnassa",
    "distributeVertically": "Jaa pystysuunnassa",
    "flipHorizontal": "Käännä vaakasuunnassa",
    "flipVertical": "Käännä pystysuunnassa",
    "viewMode": "Katselutila",
    "share": "Jaa",
    "showStroke": "Näytä viivan värin valitsin",
    "showBackground": "Näytä taustavärin valitsin",
    "toggleTheme": "Vaihda teema",
    "personalLib": "Oma kirjasto",
    "excalidrawLib": "Excalidraw kirjasto",
    "decreaseFontSize": "Pienennä kirjasinkokoa",
    "increaseFontSize": "Kasvata kirjasinkokoa",
    "unbindText": "Irroita teksti",
    "bindText": "Kiinnitä teksti säiliöön",
    "createContainerFromText": "",
    "link": {
      "edit": "Muokkaa linkkiä",
      "editEmbed": "",
      "create": "Luo linkki",
      "createEmbed": "",
      "label": "Linkki",
      "labelEmbed": "",
      "empty": ""
    },
    "lineEditor": {
      "edit": "Muokkaa riviä",
      "exit": "Poistu rivieditorista"
    },
    "elementLock": {
      "lock": "Lukitse",
      "unlock": "Poista lukitus",
      "lockAll": "Lukitse kaikki",
      "unlockAll": "Poista lukitus kaikista"
    },
    "statusPublished": "Julkaistu",
    "sidebarLock": "Pidä sivupalkki avoinna",
    "selectAllElementsInFrame": "",
    "removeAllElementsFromFrame": "",
    "eyeDropper": "",
    "textToDiagram": "",
    "prompt": ""
  },
  "library": {
    "noItems": "Kirjastossa ei ole vielä yhtään kohdetta...",
    "hint_emptyLibrary": "Valitse lisättävä kohde piirtoalueelta, tai asenna alta julkinen kirjasto.",
    "hint_emptyPrivateLibrary": "Valitse lisättävä kohde piirtoalueelta."
  },
  "buttons": {
    "clearReset": "Tyhjennä piirtoalue",
    "exportJSON": "Vie tiedostoon",
    "exportImage": "Vie kuva...",
    "export": "Tallenna nimellä...",
    "copyToClipboard": "Kopioi leikepöydälle",
    "save": "Tallenna nykyiseen tiedostoon",
    "saveAs": "Tallenna nimellä",
    "load": "Avaa",
    "getShareableLink": "Hae jaettava linkki",
    "close": "Sulje",
    "selectLanguage": "Valitse kieli",
    "scrollBackToContent": "Näytä sisältö",
    "zoomIn": "Lähennä",
    "zoomOut": "Loitonna",
    "resetZoom": "Nollaa suurennuksen taso",
    "menu": "Valikko",
    "done": "Valmis",
    "edit": "Muokkaa",
    "undo": "Kumoa",
    "redo": "Tee uudelleen",
    "resetLibrary": "Tyhjennä kirjasto",
    "createNewRoom": "Luo huone",
    "fullScreen": "Koko näyttö",
    "darkMode": "Tumma tila",
    "lightMode": "Vaalea tila",
    "zenMode": "Zen-tila",
    "objectsSnapMode": "",
    "exitZenMode": "Poistu zen-tilasta",
    "cancel": "Peruuta",
    "clear": "Pyyhi",
    "remove": "Poista",
    "embed": "",
    "publishLibrary": "Julkaise",
    "submit": "Lähetä",
    "confirm": "Vahvista",
    "embeddableInteractionButton": ""
  },
  "alerts": {
    "clearReset": "Tämä tyhjentää koko piirtoalueen. Jatketaanko?",
    "couldNotCreateShareableLink": "Jaettavan linkin luominen epäonnistui.",
    "couldNotCreateShareableLinkTooBig": "Jaettavaa linkkiä ei voitu luoda: teos on liian suuri",
    "couldNotLoadInvalidFile": "Virheellistä tiedostoa ei voitu avata",
    "importBackendFailed": "Palvelimelta tuonti epäonnistui.",
    "cannotExportEmptyCanvas": "Tyhjää piirtoaluetta ei voi viedä.",
    "couldNotCopyToClipboard": "Leikepöydälle vieminen epäonnistui.",
    "decryptFailed": "Salauksen purkaminen epäonnistui.",
    "uploadedSecurly": "Lähetys on turvattu päästä-päähän-salauksella. Excalidrawin palvelin ja kolmannet osapuolet eivät voi lukea sisältöä.",
    "loadSceneOverridePrompt": "Ulkopuolisen piirroksen lataaminen korvaa nykyisen sisältösi. Jatketaanko?",
    "collabStopOverridePrompt": "Istunnon lopettaminen korvaa aiemman, paikallisesti tallennetun piirustuksen. Jatketaanko?\n\n(Jos haluat säilyttää paikallisesti tallennetun piirustuksen, sulje selaimen välilehti lopettamisen sijaan.)",
    "errorAddingToLibrary": "Kohdetta ei voitu lisätä kirjastoon",
    "errorRemovingFromLibrary": "Kohdetta ei voitu poistaa kirjastosta",
    "confirmAddLibrary": "Tämä lisää {{numShapes}} muotoa kirjastoosi. Jatketaanko?",
    "imageDoesNotContainScene": "Tämä kuva ei näytä sisältävän piirrostietoja. Oletko ottanut käyttöön piirroksen tallennuksen viennin aikana?",
    "cannotRestoreFromImage": "Teosta ei voitu palauttaa tästä kuvatiedostosta",
    "invalidSceneUrl": "Teosta ei voitu tuoda annetusta URL-osoitteesta. Tallenne on vioittunut, tai osoitteessa ei ole Excalidraw JSON-dataa.",
    "resetLibrary": "Tämä tyhjentää kirjastosi. Jatketaanko?",
    "removeItemsFromsLibrary": "Poista {{count}} kohdetta kirjastosta?",
    "invalidEncryptionKey": "Salausavaimen on oltava 22 merkkiä pitkä. Live-yhteistyö ei ole käytössä.",
    "collabOfflineWarning": "Internet-yhteyttä ei ole saatavilla.\nMuutoksiasi ei tallenneta!"
  },
  "errors": {
    "unsupportedFileType": "Tiedostotyyppiä ei tueta.",
    "imageInsertError": "Kuvan lisääminen epäonnistui. Yritä myöhemmin uudelleen...",
    "fileTooBig": "Tiedosto on liian suuri. Suurin sallittu koko on {{maxSize}}.",
    "svgImageInsertError": "SVG- kuvaa ei voitu lisätä. Tiedoston SVG-sisältö näyttää virheelliseltä.",
    "failedToFetchImage": "",
    "invalidSVGString": "Virheellinen SVG.",
    "cannotResolveCollabServer": "Yhteyden muodostaminen collab-palvelimeen epäonnistui. Virkistä sivu ja yritä uudelleen.",
    "importLibraryError": "Kokoelman lataaminen epäonnistui",
    "collabSaveFailed": "Ei voitu tallentaan palvelimen tietokantaan. Jos ongelmia esiintyy, sinun kannatta tallentaa tallentaa tiedosto paikallisesti varmistaaksesi, että et menetä työtäsi.",
    "collabSaveFailed_sizeExceeded": "Ei voitu tallentaan palvelimen tietokantaan. Jos ongelmia esiintyy, sinun kannatta tallentaa tallentaa tiedosto paikallisesti varmistaaksesi, että et menetä työtäsi.",
    "imageToolNotSupported": "",
    "brave_measure_text_error": {
      "line1": "",
      "line2": "",
      "line3": "",
      "line4": ""
    },
    "libraryElementTypeError": {
      "embeddable": "",
      "iframe": "",
      "image": ""
    },
    "asyncPasteFailedOnRead": "",
    "asyncPasteFailedOnParse": "",
    "copyToSystemClipboardFailed": ""
  },
  "toolBar": {
    "selection": "Valinta",
    "image": "Lisää kuva",
    "rectangle": "Suorakulmio",
    "diamond": "Vinoneliö",
    "ellipse": "Soikio",
    "arrow": "Nuoli",
    "line": "Viiva",
    "freedraw": "Piirrä",
    "text": "Teksti",
    "library": "Kirjasto",
    "lock": "Pidä valittu työkalu aktiivisena piirron jälkeen",
    "penMode": "Kynätila - estä kosketus",
    "link": "Lisää/päivitä linkki valitulle muodolle",
    "eraser": "Poistotyökalu",
    "frame": "",
    "magicframe": "",
    "embeddable": "",
    "laser": "",
    "hand": "Käsi (panning-työkalu)",
    "extraTools": "",
    "mermaidToExcalidraw": "",
    "magicSettings": ""
  },
  "headings": {
    "canvasActions": "Piirtoalueen toiminnot",
    "selectedShapeActions": "Valitun muodon toiminnot",
    "shapes": "Muodot"
  },
  "hints": {
    "canvasPanning": "Piirtoalueen liikuttamiseksi pidä hiiren pyörää tai välilyöntiä pohjassa tai käytä käsityökalua",
    "linearElement": "Klikkaa piirtääksesi useampi piste, raahaa piirtääksesi yksittäinen viiva",
    "freeDraw": "Paina ja raahaa, päästä irti kun olet valmis",
    "text": "Vinkki: voit myös lisätä tekstiä kaksoisnapsauttamalla mihin tahansa valintatyökalulla",
    "embeddable": "",
    "text_selected": "Kaksoisnapsauta tai paina ENTER muokataksesi tekstiä",
    "text_editing": "Paina Escape tai CtrlOrCmd+ENTER lopettaaksesi muokkaamisen",
    "linearElementMulti": "Lopeta klikkaamalla viimeistä pistettä, painamalla Escape- tai Enter-näppäintä",
    "lockAngle": "Voit rajoittaa kulmaa pitämällä SHIFT-näppäintä alaspainettuna",
    "resize": "Voit rajoittaa mittasuhteet pitämällä SHIFT-näppäintä alaspainettuna kun muutat kokoa, pidä ALT-näppäintä alaspainettuna muuttaaksesi kokoa keskipisteen suhteen",
    "resizeImage": "Voit muuttaa kokoa vapaasti pitämällä SHIFTiä pohjassa, pidä ALT pohjassa muuttaaksesi kokoa keskipisteen ympäri",
    "rotate": "Voit rajoittaa kulman pitämällä SHIFT pohjassa pyörittäessäsi",
    "lineEditor_info": "Pidä CtrlOrCmd pohjassa ja kaksoisnapsauta tai paina CtrlOrCmd + Enter muokataksesi pisteitä",
    "lineEditor_pointSelected": "Poista piste(et) painamalla delete, monista painamalla CtrlOrCmd+D, tai liikuta raahaamalla",
    "lineEditor_nothingSelected": "Valitse muokattava piste (monivalinta pitämällä SHIFT pohjassa), tai paina Alt ja klikkaa lisätäksesi uusia pisteitä",
    "placeImage": "Klikkaa asettaaksesi kuvan, tai klikkaa ja raahaa asettaaksesi sen koon manuaalisesti",
    "publishLibrary": "Julkaise oma kirjasto",
    "bindTextToElement": "Lisää tekstiä painamalla enter",
    "deepBoxSelect": "Käytä syvävalintaa ja estä raahaus painamalla CtrlOrCmd",
    "eraserRevert": "Pidä Alt alaspainettuna, kumotaksesi merkittyjen elementtien poistamisen",
    "firefox_clipboard_write": "Tämä ominaisuus voidaan todennäköisesti ottaa käyttöön asettamalla \"dom.events.asyncClipboard.clipboardItem\" kohta \"true\":ksi. Vaihtaaksesi selaimen kohdan Firefoxissa, käy \"about:config\" sivulla.",
    "disableSnapping": ""
  },
  "canvasError": {
    "cannotShowPreview": "Esikatselua ei voitu näyttää",
    "canvasTooBig": "Piirtoalue saattaa olla liian suuri.",
    "canvasTooBigTip": "Vinkki: yritä siirtää kaukaisimpia elementtejä hieman lähemmäs toisiaan."
  },
  "errorSplash": {
    "headingMain": "Tapahtui virhe. Yritä <button>sivun lataamista uudelleen.</button>",
    "clearCanvasMessage": "Mikäli sivun lataaminen uudelleen ei auta, yritä <button>tyhjentää piirtoalue.</button>",
    "clearCanvasCaveat": " Tämä johtaa työn menetykseen ",
    "trackedToSentry": "Virhe tunnisteella {{eventId}} tallennettiin järjestelmäämme.",
    "openIssueMessage": "Olimme varovaisia emmekä sisällyttäneet tietoa piirroksestasi virheeseen. Mikäli piirroksesi ei ole yksityinen, harkitsethan kertovasi meille <button>virheenseurantajärjestelmässämme.</button> Sisällytä alla olevat tiedot kopioimalla ne GitHub-ongelmaan.",
    "sceneContent": "Piirroksen tiedot:"
  },
  "roomDialog": {
    "desc_intro": "Voit kutsua ihmisiä piirrokseesi tekemään yhteistyötä kanssasi.",
    "desc_privacy": "Älä huoli, istunto käyttää päästä-päähän-salausta, joten mitä tahansa piirrätkin, se pysyy salassa. Edes palvelimemme eivät näe mitä keksit.",
    "button_startSession": "Aloita istunto",
    "button_stopSession": "Lopeta istunto",
    "desc_inProgressIntro": "Jaettu istunto on nyt käynnissä.",
    "desc_shareLink": "Jaa tämä linkki kenelle tahansa, jonka kanssa haluat tehdä yhteistyötä:",
    "desc_exitSession": "Istunnon pysäyttäminen katkaisee yhteyden huoneeseen, mutta voit vielä jatkaa työskentelyä paikallisesti. Huomaa, että tämä ei vaikuta muihin käyttäjiin ja he voivat jatkaa oman versionsa parissa työskentelyä.",
    "shareTitle": "Liity Excalidraw live-yhteistyöistuntoon"
  },
  "errorDialog": {
    "title": "Virhe"
  },
  "exportDialog": {
    "disk_title": "Tallenna levylle",
    "disk_details": "Vie työn tiedot tiedostoon, josta sen voi tuoda myöhemmin.",
    "disk_button": "Tallenna tiedostoon",
    "link_title": "Jaettava linkki",
    "link_details": "Vie vain luku -linkkinä.",
    "link_button": "Vie linkkinä",
    "excalidrawplus_description": "Tallenna teos Excalidraw+ tilaan.",
    "excalidrawplus_button": "Vie",
    "excalidrawplus_exportError": "Ei voitu viedä Excalidraw+-palveluun tällä hetkellä..."
  },
  "helpDialog": {
    "blog": "Lue blogiamme",
    "click": "klikkaa",
    "deepSelect": "Syvävalinta",
    "deepBoxSelect": "Käytä syvävalintaa ja estä raahaus",
    "curvedArrow": "Kaareva nuoli",
    "curvedLine": "Kaareva viiva",
    "documentation": "Käyttöohjeet",
    "doubleClick": "kaksoisnapsautus",
    "drag": "vedä",
    "editor": "Muokkausohjelma",
    "editLineArrowPoints": "",
    "editText": "",
    "github": "Löysitkö ongelman? Kerro meille",
    "howto": "Seuraa oppaitamme",
    "or": "tai",
    "preventBinding": "Estä nuolten kiinnitys",
    "tools": "Työkalut",
    "shortcuts": "Pikanäppäimet",
    "textFinish": "Lopeta muokkaus (tekstieditori)",
    "textNewLine": "Lisää uusi rivi (tekstieditori)",
    "title": "Ohjeet",
    "view": "Näkymä",
    "zoomToFit": "Näytä kaikki elementit",
    "zoomToSelection": "Näytä valinta",
    "toggleElementLock": "Lukitse / poista lukitus valinta",
    "movePageUpDown": "Siirrä sivua ylös/alas",
    "movePageLeftRight": "Siirrä sivua vasemmalle/oikealle"
  },
  "clearCanvasDialog": {
    "title": "Pyyhi piirtoalue"
  },
  "publishDialog": {
    "title": "Julkaise kirjasto",
    "itemName": "Kohteen nimi",
    "authorName": "Tekijän nimi",
    "githubUsername": "GitHub-käyttäjätunnus",
    "twitterUsername": "Twitter-käyttäjätunnus",
    "libraryName": "Kirjaston nimi",
    "libraryDesc": "Kirjaston kuvaus",
    "website": "Verkkosivu",
    "placeholder": {
      "authorName": "Nimesi tai käyttäjänimesi",
      "libraryName": "Kirjastosi nimi",
      "libraryDesc": "Kirjaston kuvaus, joka auttaa ihmisiä ymmärtämään sen käyttötarkoitukset",
      "githubHandle": "GitHub-tunnuksesi (valinnainen), jotta voit muokata kirjastoa sen jälkeen kun se on lähetetty tarkastettavaksi",
      "twitterHandle": "Twitter-tunnus (valinnainen), jotta tiedämme ketä kiittää kun viestimme Twitterissä",
      "website": "Linkki henkilökohtaiselle verkkosivustollesi tai muualle (valinnainen)"
    },
    "errors": {
      "required": "Pakollinen",
      "website": "Syötä oikeamuotoinen URL-osoite"
    },
    "noteDescription": "Lähetä kirjastosi, jotta se voidaan sisällyttää <link>julkisessa kirjastolistauksessa</link>muiden käyttöön omissa piirrustuksissaan.",
    "noteGuidelines": "Kirjasto on ensin hyväksyttävä manuaalisesti. Ole hyvä ja lue <link>ohjeet</link> ennen lähettämistä. Tarvitset GitHub-tilin, jotta voit viestiä ja tehdä muutoksia pyydettäessä, mutta se ei ole ehdottoman välttämätöntä.",
    "noteLicense": "Lähettämällä hyväksyt että kirjasto julkaistaan <link>MIT-lisenssin </link>alla, mikä lyhyesti antaa muiden käyttää sitä ilman rajoituksia.",
    "noteItems": "Jokaisella kirjaston kohteella on oltava oma nimensä suodatusta varten. Seuraavat kirjaston kohteet sisältyvät:",
    "atleastOneLibItem": "Valitse vähintään yksi kirjaston kohde aloittaaksesi",
    "republishWarning": "Huom! Osa valituista kohteista on merkitty jo julkaistu/lähetetyiksi. Lähetä kohteita uudelleen vain päivitettäessä olemassa olevaa kirjastoa tai ehdotusta."
  },
  "publishSuccessDialog": {
    "title": "Kirjasto lähetetty",
    "content": "Kiitos {{authorName}}. Kirjastosi on lähetetty tarkistettavaksi. Voit seurata sen tilaa<link>täällä</link>"
  },
  "confirmDialog": {
    "resetLibrary": "Tyhjennä kirjasto",
    "removeItemsFromLib": "Poista valitut kohteet kirjastosta"
  },
  "imageExportDialog": {
    "header": "",
    "label": {
      "withBackground": "",
      "onlySelected": "",
      "darkMode": "",
      "embedScene": "",
      "scale": "",
      "padding": ""
    },
    "tooltip": {
      "embedScene": ""
    },
    "title": {
      "exportToPng": "",
      "exportToSvg": "",
      "copyPngToClipboard": ""
    },
    "button": {
      "exportToPng": "",
      "exportToSvg": "",
      "copyPngToClipboard": ""
    }
  },
  "encrypted": {
    "tooltip": "Piirroksesi ovat päästä-päähän-salattuja, joten Excalidrawin palvelimet eivät koskaan näe niitä.",
    "link": "Blogiartikkeli päästä päähän -salauksesta Excalidraw:ssa"
  },
  "stats": {
    "angle": "Kulma",
    "element": "Elementti",
    "elements": "Elementit",
    "height": "Korkeus",
    "scene": "Teos",
    "selected": "Valitut",
    "storage": "Tallennustila",
    "title": "Tilastoja nörteille",
    "total": "Yhteensä",
    "version": "Versio",
    "versionCopy": "Klikkaa kopioidaksesi",
    "versionNotAvailable": "Versio ei saatavilla",
    "width": "Leveys"
  },
  "toast": {
    "addedToLibrary": "Lisätty kirjastoon",
    "copyStyles": "Tyylit kopioitiin.",
    "copyToClipboard": "Kopioitiin leikepöydälle.",
    "copyToClipboardAsPng": "Kopioitiin {{exportSelection}} leikepöydälle PNG:nä\n({{exportColorScheme}})",
    "fileSaved": "Tiedosto tallennettu.",
    "fileSavedToFilename": "Tallennettiin kohteeseen {filename}",
    "canvas": "piirtoalue",
    "selection": "valinta",
    "pasteAsSingleElement": "Käytä {{shortcut}} liittääksesi yhtenä elementtinä,\ntai liittääksesi olemassa olevaan tekstieditoriin",
    "unableToEmbed": "",
    "unrecognizedLinkFormat": ""
  },
  "colors": {
    "transparent": "Läpinäkyvä",
    "black": "",
    "white": "",
    "red": "",
    "pink": "",
    "grape": "",
    "violet": "",
    "gray": "",
    "blue": "",
    "cyan": "",
    "teal": "",
    "green": "",
    "yellow": "",
    "orange": "",
    "bronze": ""
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "Kaikki tietosi on tallennettu paikallisesti selaimellesi.",
      "center_heading_plus": "Haluatko sen sijaan mennä Excalidraw+:aan?",
      "menuHint": "Vie, asetukset, kielet, ..."
    },
    "defaults": {
      "menuHint": "Vie, asetukset ja lisää...",
      "center_heading": "Kaaviot. Tehty. Yksinkertaiseksi.",
      "toolbarHint": "Valitse työkalu ja aloita piirtäminen!",
      "helpHint": "Pikanäppäimet & ohje"
    }
  },
  "colorPicker": {
    "mostUsedCustomColors": "",
    "colors": "",
    "shades": "",
    "hexCode": "",
    "noShades": ""
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "",
        "button": "",
        "description": ""
      },
      "saveToDisk": {
        "title": "",
        "button": "",
        "description": ""
      },
      "excalidrawPlus": {
        "title": "",
        "button": "",
        "description": ""
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "",
        "button": "",
        "description": ""
      },
      "shareableLink": {
        "title": "",
        "button": "",
        "description": ""
      }
    }
  },
  "mermaid": {
    "title": "",
    "button": "",
    "description": "",
    "syntax": "",
    "preview": ""
  }
}
